import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ReactDOM.createRoot(document.getElementById('root')!).render(
//     <React.StrictMode>
//         <App />
//     </React.StrictMode>,
// )

const storedVersion = localStorage.getItem("appVersion");
const currentVersion = process.env.REACT_APP_VERSION || "1.0.0"; // Versione di default
if (!storedVersion || storedVersion !== currentVersion) {
    localStorage.clear();
    localStorage.setItem("appVersion", currentVersion);
    window.location.reload();
} else {    
    const root = document.getElementById('root')!;
    root.dataset.version = storedVersion;
    ReactDOM.createRoot(root).render(<App />);
}
